import React from "react";
import { Spinner } from "discover.medical.react-component-library";
import { Overlay } from "./MainSpinner.styled";

const MainSpinner = () => (
  <Overlay data-testid="main-spinner-root">
    <Spinner size="lg" />
  </Overlay>
);

MainSpinner.displayName = "MainSpinner";

export default MainSpinner;
